import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CSButtonComponent } from 'src/app/shared/components/cs-button/cs-button.component';
import { CSIconButtonComponent } from 'src/app/shared/components/cs-icon-button/cs-icon-button.component';
import { EmptyModule } from 'src/app/shared/components/empty/empty.module';
import { BonusDetailList } from 'src/app/shared/interfaces/bonus.interface';
import { ActiveBonus, EligibleBonus } from 'src/app/shared/interfaces/new-bonus-wallet.interface';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { MatConnectedDialogRef } from 'src/app/shared/service/connected-dialog';
import { UserAssetsService } from '../../user-asset/user-assets.service';

export type BonusItem =
  | { type: 'detail'; item: BonusDetailList }
  | { type: 'active'; item: ActiveBonus }
  | { type: 'eligible'; item: EligibleBonus };

@Component({
  selector: 'app-bonuses-rules',
  standalone: true,
  imports: [CSButtonComponent, CSIconButtonComponent, PipesModule, EmptyModule],
  templateUrl: './bonuses-rules.component.html',
  styleUrl: './bonuses-rules.component.scss',
})
export class BonusesRulesComponent implements OnInit {
  isMultiplePrize: boolean = false;
  currencyAmountList: Array<{
    currency: string;
    minAmount: number;
    maxAmount: number;
    grantType?: string;
  }> = [];
  activityRules: string = '';
  activityName: string = '';

  constructor(
    private userAssetsService: UserAssetsService,
    private dialogRef: MatConnectedDialogRef<BonusesRulesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BonusItem,
  ) {}
  ngOnInit(): void {
    this.initData(this.data);
  }

  initData(data: BonusItem) {
    if (!data.item) {
      return;
    }
    switch (data.type) {
      case 'active':
        this.activityName = data.item.activityName;
        this.activityRules = data.item.activityContent;
        break;
      case 'eligible':
        this.activityName = data.item.activityName;
        this.activityRules = data.item.activityContent;
        console.log('data.item', data.item);
        this.initCurrencyAmountList(data.item);
        break;
      case 'detail':
        this.activityName = data.item.title;
        this.activityRules = data.item.description || '';
        break;
      default:
        break;
    }
  }
  initCurrencyAmountList(item: EligibleBonus) {
    this.isMultiplePrize = this.shouldDisplayBonusRange(item);
    const { minBonusAmount, maxBonusAmount, currency: singleCurrency, currencyList = [] } = item;
    this.currencyAmountList = currencyList.map((currency: string) => {
      const rate = this.getExchangeRate(singleCurrency, currency);
      return {
        currency,
        minAmount: singleCurrency === currency ? minBonusAmount : minBonusAmount / rate,
        maxAmount: singleCurrency === currency ? maxBonusAmount : maxBonusAmount / rate,
        grantType: item.grantType,
      };
    });
  }

  shouldDisplayBonusRange(item: EligibleBonus): boolean {
    if (item.hasFixedAmountType) {
      return item.isMultiplePrize || item.minBonusAmount !== item.maxBonusAmount;
    }

    return item.isMultiplePrize;
  }

  isFCFS(type: string | undefined): boolean {
    return type === 'FreeChip' || type === 'FreeSpin';
  }

  /**
   * 獲取目標幣種的匯率
   *
   * @param baseCurrency
   * @param targetCurrency
   */
  private getExchangeRate(baseCurrency: string, targetCurrency: string): number {
    return (
      this.userAssetsService
        .getRatesBaseCurrency(this.userAssetsService.allRate.getValue(), baseCurrency)
        .rates?.find((r: any) => r.currency === targetCurrency)?.rate || 1
    );
  }
  close() {
    this.dialogRef.close();
  }
}
